'use strict';

var win                         = require( '@rei/browser-shim' ).win;
var doc                         = win.document;
var $                           = require( 'jquery' );
var debounce                    = require( 'lodash/debounce' );
var throttle                    = require( 'lodash/throttle' );
var scrollTop                   = 0;
var windowElement               = $( win );
var scrollFunctions             = [];
var resizeFunctions             = [];
var resizedFunctions            = [];
var domChangeFunctions          = [];
var pushstateChangeFunctions    = [];
var replaceStateChangeFunctions = [];
var windowHeight;
var windowWidth;

/**
 * Add pushState and replaceState handlers to window history object
 * @param  {Object} history Window history object
 */
( function( history ){
    var pushState = history.pushState;
    history.pushState = function( state ) {
        if ( typeof history.onpushstate == "function" ) {
            history.onpushstate( { state: state } );
        }
        // whatever else you want to do
        // maybe call onhashchange e.handler
        return pushState.apply( history, arguments );
    }
    var replaceState = history.replaceState;
    history.replaceState = function( state ) {
        if ( typeof history.onreplacestate == "function" ) {
            history.onreplacestate( { state: state } );
        }
        return replaceState.apply( history, arguments );
    }
})( window.history );

var runArrayOfFunctions = function ( arrayOfFunctions ) {
    if ( arrayOfFunctions.length ) {
        arrayOfFunctions.forEach( function( pushedFunctions ) {
            if ( pushedFunctions && typeof pushedFunctions === 'function' ) pushedFunctions();
        });
    }
};

var pushstateChange = function () {
    runArrayOfFunctions( pushstateChangeFunctions );
};

var replaceStateChange = function () {
    runArrayOfFunctions( replaceStateChangeFunctions );
};

window.onpopstate = function ( event ) {
    if ( event.state ) {
        // history changed because of pushState/replaceState
    }
    setTimeout( pushstateChange, 100 );
};

history.onpushstate = function( e ) {
    // Get Query String After Popstate is Updated ( delay workaround )
    setTimeout( pushstateChange, 100 );
};

history.onreplacestate = function( e ) {
    // Get Query String After Popstate is Updated ( delay workaround )
    setTimeout( replaceStateChange, 100 );
};

var domChange =  debounce( function () {
    runArrayOfFunctions( domChangeFunctions );
}, 500);

/* Keep Track of Window Height & Width for Scroll Logic */
var recordHeight = function () {
    windowHeight = parseInt( windowElement.height() );
};
resizeFunctions.push( recordHeight );

var recordWidth = function () {
    windowWidth = parseInt( windowElement.width() );
}
resizeFunctions.push( recordWidth );

var getWindowHeight = function () {
    return windowHeight;
};

var getWindowWidth = function () {
    return windowWidth;
}

var getScrollTop = function () {
    return scrollTop;
};

var bindScrollEvent = function () {
    windowElement.on( 'scroll', throttle( function () {
        scrollTop = parseInt( windowElement.scrollTop() );
        runArrayOfFunctions( scrollFunctions );
    }, 100) );
};

var bindResizeEvent = function () {
    windowElement.on( 'resize', throttle( function () {
        recordHeight();
        runArrayOfFunctions( resizeFunctions );
    }, 250) );
};

var bindResizedEvent = function () {
    windowElement.on( 'resize', debounce( function () {
        runArrayOfFunctions( resizedFunctions );
    }, 500) );
}

var bindAllEvents = function () {
    recordHeight();
    recordWidth();
    /* Set ScrollTop for Onload of In Page Anchors, Browser Scroll Refresh or Back Button History */
    scrollTop = parseInt( windowElement.scrollTop() );
    bindScrollEvent();
    bindResizeEvent();
    bindResizedEvent();
};

module.exports = {
    getScrollTop: getScrollTop,
    getWindowHeight: getWindowHeight,
    getWindowWidth: getWindowWidth,
    scrollFunctions: scrollFunctions,
    resizeFunctions: resizeFunctions,
    resizedFunctions: resizedFunctions,
    domChangeFunctions: domChangeFunctions,
    domChange: domChange,
    pushstateChangeFunctions: pushstateChangeFunctions,
    replaceStateChangeFunctions: replaceStateChangeFunctions,
    recordHeight: recordHeight,
    recordWidth: recordWidth,
    bindAllEvents: bindAllEvents,
    bindResizeEvent: bindResizeEvent,
    bindResizedEvent: bindResizedEvent,
    bindScrollEvent: bindScrollEvent,
    init: bindAllEvents
};
